import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'Components/molecules/Link';
import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

const HelpCentreBlock = ({
  context: {
    cssPrefix,
  },
  data: {
    ctaLabel,
    ctaUrl,
    description,
    title,
  },
}) => (
  <div className={`${cssPrefix}__help-centre-block`}>
    <p className={`${cssPrefix}__help-centre-block--title`}>{title}</p>
    <p className={`${cssPrefix}__help-centre-block--description`}>{description}</p>
    <Link
      extraClassNames={{
        [`${cssPrefix}__help-centre-block__link`]: true,
        '-link-as-button': true,
      }}
      href={ctaUrl}
    >
      {ctaLabel}
    </Link>
  </div>
);

HelpCentreBlock.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  data: PropTypes.shape({
    ctaLabel: PropTypes.string,
    ctaUrl: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
  }),
};

HelpCentreBlock.defaultProps = {
  context: {},
  data: {
    ctaLabel: '',
    ctaUrl: '',
    description: '',
    title: '',
  },
};

export default withPolaris(HelpCentreBlock);
